export default __webpack_public_path__ + "static/media/simple_hover.1808ed00.svg";